import React, {useState, useEffect} from "react";
import { Button, TextField, Card, CardContent, Typography, Select, MenuItem } from "@mui/material";
import background from '../../assets/logo.png'
import axios from 'axios'
import { useAuth } from "../../context/AuthContext";
    const Login = () => {
        const [userId, setUserId] = useState('');
        const [password, setPassword] = useState('');
        const { login, setToken } = useAuth();

        const changeUSerId = (event) =>{
            setUserId(event.target.value);   
        }
        const changePassword = (event) =>{
            setPassword(event.target.value)
        }

        useEffect(()=>{
            console.log(userId)
            console.log(password)
        },[userId, password])
        const signInUser = async () =>{
            try{
            let data = {
                email : userId,
                password: password
            }
              const loginUser = await axios.post("https://surveryindia.xyz/api/v1/admin/login", data);
            console.log(loginUser.data);
            if(loginUser.data.status == 200){
                localStorage.setItem('authToken',JSON.stringify(loginUser?.data?.data))
                login();
                setToken(loginUser?.data?.data)
                console.log("login successful")
            }
        } catch(error){
            console.log("Unable to login")
            console.log(error)
        }
        }
      return (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100vh", backgroundColor: "#f4f4f4",marginLeft:-30 }}>
          {/* Header */}
          <div style={{ position: "absolute", top: 0, left: 0, width: "100%", backgroundColor: "#0000cc", height: "60px", display: "flex", alignItems: "center", justifyContent: "space-between",zIndex:100 }}>
            <Typography variant="h6" style={{ color: "white", fontWeight: "bold" }}></Typography>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
              <img src={background} alt="Logo" style={{ width: "130px", marginTop: "150px",paddingRight:"50px",marginBottom:"20px" }} />
              <Select defaultValue="English" variant="outlined" style={{ color: "blue", background: "white", borderRadius: "4px", height: "35px",marginRight:50  }}>
                <MenuItem value="English">English</MenuItem>
                <MenuItem value="Hindi">Hindi</MenuItem>
              </Select>
            </div>
          </div>
          
          {/* Background Logo */}
          <div style={{ position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center", opacity: 0.1 }}>
            <img src={background} alt="Background Logo" style={{ width: "50%" }} />
          </div>
          
          {/* Login Card */}
          <Card style={{ width: "400px", zIndex: 10, borderRadius: "10px", boxShadow: "0 4px 10px rgba(0,0,0,0.2)" }}>
            <CardContent style={{borderWidth:1}}>
              <Typography variant="h5" align="center" gutterBottom style={{ fontWeight: "bold" }}>Admin Login</Typography>
              <form>
                <TextField label="UserID" variant="outlined" fullWidth margin="normal" style={{ borderColor: "blue" }} onChange={changeUSerId}/>
                <TextField label="Password" type="password" variant="outlined" fullWidth margin="normal" style={{ borderColor: "blue" }} onChange={changePassword}/>
                <Button variant="contained"  style={{ marginTop: "16px", backgroundColor: "#FF5722", color: "white" }} onClick={()=>{signInUser()}}>
                  Sign In
                </Button>
              </form>
            </CardContent>
          </Card>
        </div>
      );
    };

export default Login;
